import { createSlice } from "@reduxjs/toolkit";
import { selectGlobalVariables as selectGlobalVariablesFromCritical, selectCriticalDataLoading, selectCriticalDataError } from "./criticalDataSlice";

/**
 * DEPRECATED: This slice is maintained for backward compatibility
 * Global variables now come from criticalDataSlice via unified /critical-data endpoint
 * Components should use criticalDataSlice selectors directly or call fetchAllCriticalData
 */

const GlobalVariablesSlice = createSlice({
  name: "globalVariables",
  initialState: {
    data: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: () => {
    // No longer listening to fetchData actions
    // Data comes from criticalDataSlice
  },
});

// Selectors - proxy to criticalDataSlice
export const selectGlobalVariables = (state) => {
  // Try to get from criticalDataSlice first
  const criticalData = selectGlobalVariablesFromCritical(state);
  if (Array.isArray(criticalData)) {
    return criticalData;
  }
  // Fallback to local state for backward compatibility
  return state.globalVariables.data;
};

export const selectGlobalVariablesStatus = (state) => {
  // Map criticalData loading to status
  const loading = selectCriticalDataLoading(state);
  if (loading) return "loading";
  
  const data = selectGlobalVariablesFromCritical(state);
  if (Array.isArray(data)) return "succeeded";
  
  return state.globalVariables.status;
};

export const selectGlobalVariablesError = (state) => {
  const criticalError = selectCriticalDataError(state);
  return criticalError || state.globalVariables.error;
};

/**
 * DEPRECATED: fetchGlobalVariables
 * Use fetchAllCriticalData from criticalDataSlice instead
 */
export const fetchGlobalVariables = () => (dispatch, getState) => {
  console.warn("fetchGlobalVariables is deprecated. Use fetchAllCriticalData from criticalDataSlice instead.");
  // No-op: data is fetched via criticalDataSlice
};

export default GlobalVariablesSlice.reducer;
